import { render, staticRenderFns } from "./CustomerListComponent.vue?vue&type=template&id=f9e28af8&"
import script from "./CustomerListComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports